import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetItemModel } from "@factory/model/query-model-item";
import { itemFormDefault } from "./form.default";
import { ItemFormSchema } from "./form.rule";

export const useFormDefaultItem = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetItemModel | undefined) => {
    return !cachedValue
      ? itemFormDefault
      : ({
          name: cachedValue.name,
          description: cachedValue.description,
          amount: cachedValue.amount,
          tenant: cachedValue.tenant,
          duration: cachedValue.duration,
        } as ItemFormSchema);
  };

  return {
    getDefault,
  };
};
